import React from 'react';

import { Dropdown } from 'semantic-ui-react';

const ButtonDropdown = ({ options, value, onChange, text }) => (
  <Dropdown
    button
    options={options}
    onChange={(e, data) => {
      if (e.type === 'click') { // override default behavior of dropdown
        onChange(data.value);
      }
    }}
    value={value}
    text={text}
    className="ui primary button"
    selectOnBlur={false}
  />
);

export default ButtonDropdown;
